import DataLayer from './DataLayer';

export type { DataLayerEvent } from './DataLayer';

export default DataLayer;
